import { FallOutlined, RiseOutlined } from '@ant-design/icons';

export const defineDynamicIcon = (value: number) => {
  if (value > 0) {
    return <RiseOutlined />;
  }

  if (value < 0) {
    return <FallOutlined />;
  }

  return null;
};
